import { PrismicExternalLink, PrismicLink } from 'prismic/types';

export const isValidLink = (link: PrismicLink | PrismicExternalLink): boolean => {
  return !!(link.url || link.link_type === 'Document');
};
